import Dep from './Dep';
import Observer from "./Observer";
import supported from './isSupoortObjectDefineProperty';
import { isEmpty } from './util';

export default function defineReactive (data, key, val) {
    let childOb = observe(val);
    let dep;
    if (!childOb) {
        dep = new Dep();
    }
    if (supported) {
        Object.defineProperty(data, key, {
            enumerable: true,
            configurable: true,
            get: function () {
                if (childOb) {
                    childOb.dep.depend();
                } else {
                    dep && dep.depend();
                }
                return val;
            },
            set: function (newVal) {
                if (val === newVal) {
                    return;
                }
                val = newVal;
                if (childOb) {
                    childOb.dep.notify();
                } else {
                    dep && dep.notify();
                }
            }
        })
    } else {
        if (isEmpty(data.__vm__hash)) {
            data.__vm__hash = {};
            data.__vm__set = function (key, newVal) {
                if (data[key] === newVal) {
                    return;
                }
                data[key] = newVal;
                if (data.__vm__hash[key]) {
                    if (childOb) {
                        childOb.dep.notify();
                    } else {
                        dep && dep.notify();
                    }
                }
            }
            data.__vm__get = function (key) {
                if (data.__vm__hash[key]) {
                    if (childOb) {
                        childOb.dep.depend();
                    } else {
                        dep && dep.depend();
                    }
                }
                return data[key];
            }
            data.__vm__hash[key] = true;
        } else {
            data.__vm__hash[key] = true;
        }
    }
}

function isObject (obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

function observe (value) {
    if (!isObject(value)) {
        return;
    }
    let ob;
    if (value.hasOwnProperty('__ob__') && value.__ob__ instanceof Observer) {
        ob = value.__ob__;
    } else {
        ob = new Observer(value);
    }
    return ob;
}